import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import JsonLd, { generateBreadcrumbSchema } from '@/components/seo/JsonLd';

interface BreadcrumbItem {
  name: string;
  path: string;
}

interface PageBreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const PageBreadcrumb = ({ items, className = '' }: PageBreadcrumbProps) => {
  const baseUrl = 'https://ifixappleservicecenter.in';
  
  // Generate schema items with full URLs
  const schemaItems = [
    { name: 'Home', url: baseUrl },
    ...items.map((item) => ({
      name: item.name,
      url: `${baseUrl}${item.path}`,
    })),
  ];

  return (
    <>
      <JsonLd data={generateBreadcrumbSchema(schemaItems)} />
      <nav 
        aria-label="Breadcrumb" 
        className={`flex items-center gap-1 text-sm ${className}`}
      >
        <ol className="flex items-center gap-1 flex-wrap">
          <li className="flex items-center">
            <Link
              to="/"
              className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Home className="w-4 h-4" />
              <span className="sr-only sm:not-sr-only">Home</span>
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={item.path} className="flex items-center">
              <ChevronRight className="w-4 h-4 text-muted-foreground mx-1" />
              {index === items.length - 1 ? (
                <span className="text-foreground font-medium" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default PageBreadcrumb;
